var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"statics-header",style:([typeof _vm.backgroundImg !== 'undefined'
    ? _vm.bgImgGradient
      ? { background: `${_vm.bgImgGradient}, url(${_vm.backgroundImg}) ${_vm.bgExtra}` }
      : { backgroundImage: `url(${_vm.backgroundImg})` }
    : null])},[_c('h1',{staticClass:"statics-header__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }